<template>
  <div>
    <toolbar-right-menu-actions-dialog
      :show="showRightMenuActionsDialog"
      :actions="rightMenuActions"
      @onActionNotSelected="onActionNotSelected"
      @onActionSelected="onActionSelected"
      ></toolbar-right-menu-actions-dialog>

    <confirmation-dialog
      :show="showLogoutConfirmationDialog"
      confirmation-message="Are you sure you want to logout?"
      @onConfirm="onLogoutConfirm"
      @onNotConfirm="showLogoutConfirmationDialog=false"
      ></confirmation-dialog>

    <ContactSupportItem
      :contact-support-actions-event="contactSupportEvent"
      @resetContactSupportEvent="contactSupportEvent=false"
      ></ContactSupportItem>
  </div>
</template>

<script>

  import ConfirmationDialog from "../dialogs/ConfirmationDialog";
  import ToolbarRightMenuActionsDialog from "../dialogs/ToolbarRightMenuActionsDialog";
  import ContactSupportItem from "./ContactSupportItem";
  import UrlParams from "../../data/model/UrlParams";
  import PrefManager from "../../data/model/PrefManager";
  import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
  import { ToolbarMenuItems } from "../../utils/ToolbarMenuItems";
  import ActivityNavigator, { Activities } from "../../utils/ActivityNavigator";
  import AuthenticationService from "../core/authentication/AuthenticationService";

  export default {
    name: "ToolBarRightActionsItem",
    components: { ToolbarRightMenuActionsDialog, ContactSupportItem, ConfirmationDialog },
    data: () => ({
      showRightMenuActionsDialog: false,
      contactSupportEvent: false,
      showLogoutConfirmationDialog: false
    }),

    props: {
      rightMenuActionsEvent: {
        type: Boolean,
        required: true,
        default: false
      },

      rightMenuActions: {
        type: Array,
        default: () => [
          ToolbarMenuItems.CONTACT_SUPPORT,
          ToolbarMenuItems.LOGOUT,
          ToolbarMenuItems.CLOSE
        ]
      },

      closeActionNavigationActivity: {
        type: String,
        default: Activities.LOAN_DETAILS
      }
    },

    methods: {
      onActionSelected(action) {
        this.showRightMenuActionsDialog = false;
        if (action === ToolbarMenuItems.LOGOUT) {
          this.showLogoutConfirmationDialog = true;
        } else if (action === ToolbarMenuItems.CLOSE) {
          if (this.closeActionNavigationActivity) {
            ActivityNavigator.navigateTo(this.closeActionNavigationActivity);
          }
        } else if (action === ToolbarMenuItems.CONTACT_SUPPORT) {
          this.contactSupportEvent = true;
        } else {
          this.$emit("onActionSelected", action);
        }
        this.$emit("resetRightMenuActionsEvent", {});
      },

      onActionNotSelected() {
        this.showRightMenuActionsDialog = false;
        this.$emit("resetRightMenuActionsEvent", {});
      },

      onLogoutConfirm() {
        AuthenticationService.logout();
        PrefManager.clearPrefs();
        LoanScopeDataHolder.clearLoanScopeData();
        UrlParams.clearUrlData();
        ActivityNavigator.navigateTo(Activities.LOGIN);
      }
    },

    watch: {
      rightMenuActionsEvent() {
        if (this.rightMenuActionsEvent) {
          this.showRightMenuActionsDialog = true;
        }
      }
    }
  };
</script>

<style scoped>

</style>
